import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const rows = this.element.querySelectorAll("tr.cursor-pointer");
    rows.forEach((row) => {
      row.addEventListener("click", (event) => {
        const nextRow = event.target.closest('tr').nextElementSibling;
        const rowContent = nextRow.querySelector(".row-content");
        rowContent.classList.toggle("max-h-0");
        rowContent.classList.toggle("max-h-96");
      });
    });
  }
}